import React from 'react';
import { ScrollView, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import mergeStyles from '../../util/mergeStyles';
import Drawer from '../Drawer/Drawer';
import findChildren from '@alucio/lux-ui/src/util/findChildren';
const Page = (props) => {
    const { children } = props;
    const styles = mergeStyles(props);
    const noop = () => { };
    const [DrawerContentComponent] = findChildren(DrawerContent, children);
    const { children: drawerChildren, open, onClose, ...rest } = DrawerContentComponent?.[0]?.props ?? {};
    return (<Drawer open={open ?? false} drawerContent={drawerChildren} onClose={onClose ?? noop} {...rest}>
      <ScrollView contentContainerStyle={styles}>
        {children}
      </ScrollView>
    </Drawer>);
};
const SafeHeader = (props) => {
    const { children } = props;
    const insets = useSafeAreaInsets();
    const S = {
        safeTop: {
            paddingTop: insets.top,
        },
    };
    return <View style={mergeStyles(props, S.safeTop)}>{children}</View>;
};
const DrawerContent = () => {
    return null;
};
Page.displayName = 'Page';
SafeHeader.displayName = 'SafeHeader';
DrawerContent.displayName = 'DrawerContent';
Page.SafeHeader = SafeHeader;
Page.DrawerContent = DrawerContent;
export default Page;
//# sourceMappingURL=Page.js.map